<header id="top" class="bg-white text-neutral-900 z-30 py-4 px-6">
  <div class="max-w-[80rem] mx-auto flex gap-4 items-center whitespace-nowrap">
    <a routerLink="/" class="shrink-0">
      <img src="assets/images/logo.svg" alt="Logo" class="w-[90px] lg:w-[120px] xl:w-40">
    </a>
    <div class="flex-1"></div>
    <div class="flex items-center gap-3">
      @if (supabase.session()) {
        <button
          (click)="kpiOpen.set(true)"
          class="flex items-center gap-2 text-[#0ab2d7] border border-[#0ab2d7] px-4 py-2 rounded-full text-sm font-semibold hover:bg-[#0ab2d7] hover:text-white transition-all"
          aria-label="Ouvrir le dashboard KPIs"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="3" width="6" height="18" rx="1"/><rect x="9" y="8" width="6" height="13" rx="1"/><rect x="16" y="13" width="6" height="8" rx="1"/>
          </svg>
          Analytics
        </button>
        <button (click)="logout()" class="hover:text-[#0ab2d7] hover:bg-transparent border border-[#0ab2d7] px-4 py-2 rounded-full text-sm font-semibold bg-[#0ab2d7] text-white transition-all">
          Déconnexion
        </button>
      } @else {
        <a routerLink="/sign-in" class="text-[#0ab2d7] border border-[#0ab2d7] px-4 py-2 rounded-full text-sm font-semibold hover:bg-[#0ab2d7] hover:text-white transition-all">
          Connexion
        </a>
      }
    </div>
  </div>
</header>

@if (kpiOpen()) {
  <app-kpi-popup (closed)="kpiOpen.set(false)" />
}
